// extracted by mini-css-extract-plugin
module.exports = {"accordion":"SizeTable_accordion__i8uF_","sizeTable":"SizeTable_sizeTable__yjqOJ"};